<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div 
                class="modal-container" 
                :class="{ 
                    'modal-container--lg' : size && size == 'lg',
                    'modal-container--md' : size && size == 'md' 
                }
            ">
                <div class="modal-header">
                    <slot name="header">{{ header }}</slot>
                    <span class="modal-header-close material-icons" @click="$emit('closeModal', true)">clear</span>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'Modal',

    data() {

        return {

            modal: null
        }
    },

    props: {

        header: {

            type: String,
            required: true
        },

        size: {

            type: String,
            required: false
        },

        show: {

            type: Boolean,
            required: false,
            default: true
        }
    },

    emits: [

        'closeModal'
    ],

    mounted() {

        const self = this
        const modalWrapper = document.getElementsByClassName('modal-wrapper')[0]
        const modalBody = document.getElementsByClassName('modal-container')[0]
        const scrollbarWidth = window.innerWidth - document.body.offsetWidth

        document.body.style.overflow = this.show ? 'hidden' : ''
        document.body.style.paddingRight = this.show ? scrollbarWidth + 'px' : ''

        // Переносим модальное окно в корень body [головняк с позиционированием = disable]
        this.modal = document.getElementsByClassName('modal-mask')[0]
        document.body.appendChild(this.modal)

        // Клик вне модального окна закрывает его
        modalWrapper.addEventListener('mousedown', function(event) {

            if(!modalBody.contains(event.target)) {

                self.$emit('closeModal', true)
            }
        })

        // Закрытие модального окна по нажатию Esc
        document.addEventListener('keyup', event => event.code == "Escape" ? this.$emit('closeModal', true) : null )
    },

    beforeUnmount() {

        document.body.style.overflow = ''
        document.body.style.paddingRight = ''

        document.body.removeChild(this.modal)
    },

    watch: {

        show(mode) {

            const scrollbarWidth = window.innerWidth - document.body.offsetWidth

            document.body.style.overflow = mode ? 'hidden' : ''
            document.body.style.paddingRight = mode ? scrollbarWidth + 'px' : ''

        }
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/scss/components/modal.scss';
</style>